import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptInvite } from '../../api/auth.ts';
import { ApiError } from '../../api/client.ts';
import { Button, TextField } from '../../components/ui.tsx';

export function AcceptInvitePage() {
  const qc = useQueryClient();
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') ?? '';
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');

  const mut = useMutation({
    mutationFn: () => acceptInvite({ token, name, password }),
    onSuccess: async () => {
      await qc.invalidateQueries();
      window.location.href = '/';
    },
  });

  const errorMsg = mut.error instanceof ApiError ? mut.error.message : undefined;

  if (!token) {
    return (
      <div className="auth-wrap">
        <div className="auth-card">
          <div className="brand">
            <span>SeenCast</span>
          </div>
          <div className="brand-sub">Invalid invite</div>
          <p className="text-dim">This invite link is missing its token. Ask your admin to resend it.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrap">
      <form
        className="auth-card"
        onSubmit={(e) => {
          e.preventDefault();
          mut.mutate();
        }}
      >
        <div className="brand">
          <span>SeenCast</span>
        </div>
        <div className="brand-sub">Join your team</div>
        <p className="text-dim mb-4">Set your name and a password to accept the invitation.</p>
        <TextField label="Your name" value={name} onChange={(e) => setName(e.target.value)} required />
        <TextField
          label="Password"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={errorMsg}
          required
          minLength={6}
        />
        <Button variant="primary" type="submit" disabled={mut.isPending} style={{ width: '100%' }}>
          {mut.isPending ? 'Joining…' : 'Accept invite'}
        </Button>
      </form>
    </div>
  );
}
